import { render } from "./NoticiaCard.vue?vue&type=template&id=d12b7e9e&scoped=true"
import script from "./NoticiaCard.vue?vue&type=script&lang=js"
export * from "./NoticiaCard.vue?vue&type=script&lang=js"

import "./NoticiaCard.vue?vue&type=style&index=0&id=d12b7e9e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d12b7e9e"]])

export default __exports__